import { FC } from "react";

import { ISoftValidationErrorBase, RydeUiUnit } from "@ryde/shared";

import { SoftValidationErrorItem } from "./soft-validation.error-item";

interface ISoftValidationErrorListProps {
  entity: RydeUiUnit;
  errors: ISoftValidationErrorBase[];
}

export const SoftValidationErrorList: FC<ISoftValidationErrorListProps> = ({
  entity,
  errors,
}) => {
  return errors.map(error => (
    <SoftValidationErrorItem key={error.type} entity={entity} error={error} />
  ));
};
